import { createFileRoute } from '@tanstack/react-router';
import { DeviceAssignmentPage } from '@/features/device-assignment';

export const Route = createFileRoute('/_app/device-assignment')({
  component: DeviceAssignmentPage,
});
